<template>
    <modal-dialog ref="modalDialog" @close="reset">
        <template v-slot:title>
            {{
                isEdit ? "Edit Item" : isItemPage ? "New Item" : "New Activity"
            }}
        </template>
        <template v-slot:body>
            <div>
                <item-page
                    ref="itemPage"
                    v-show="isItemPage"
                    :form-data="form.item"
                    :is-edit="isEdit"
                    @update-form="updateItemForm"
                    @is-save-disabled="state => (saveState.item = !state)"
                />
                <activity-page
                    ref="activityPage"
                    v-if="isActivityPage"
                    :form-data="form.activity"
                    :quantity="form.item.quantity"
                    @update-form="
                        formActivity => (form.activity = formActivity)
                    "
                    @is-save-disabled="state => (saveState.activity = !state)"
                    :item="form.item.item"
                />
            </div>
        </template>
        <template v-slot:confirmBtn>
            <div class="ml-auto">
                <div v-if="!isSaving">
                    <button
                        v-if="isActivityPage && isAddAsActivity"
                        type="button"
                        class="btn btn-primary mr-2"
                        @click="back"
                    >
                        Back
                    </button>

                    <button
                        v-if="isItemPage && isAddAsActivity"
                        type="button"
                        class="btn btn-primary"
                        @click="next"
                        :disabled="isItemPageSaveDisabled"
                    >
                        Next
                    </button>

                    <b-button-group
                        v-if="
                            (isItemPage && !isAddAsActivity) ||
                            (isActivityPage && isAddAsActivity)
                        "
                    >
                        <b-dropdown
                            left
                            split
                            text="Save + Done"
                            variant="primary"
                            :disabled="
                                isItemPageSaveDisabled ||
                                isActivityPageSaveDisabled
                            "
                            @click="save(false)"
                        >
                            <b-dropdown-item @click="save(true)">
                                Save + Add New
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-button-group>
                </div>
                <loader v-if="isSaving" :margin="1"></loader>
            </div>
        </template>
    </modal-dialog>
</template>

<script>
import ModalDialog from "@/components/commons/modal-dialog";
import ItemPage from "@/components/setting-template/bundle-invoice/modal/item";
import ActivityPage from "@/components/setting-template/bundle-invoice/modal/activity";
import Loader from "@/module/commons/loader";

const ITEM_PAGE = "item";
const ACTIVITY_PAGE = "activity";

export default {
    components: {
        ModalDialog,
        ItemPage,
        ActivityPage,
        Loader
    },
    data() {
        return {
            page: ITEM_PAGE,
            isSaving: false,
            isAddAsActivity: false,
            item: null,
            saveState: {
                item: true,
                activity: false
            },
            form: {
                item: {},
                activity: {}
            },
            isEdit: false
            // title: "New Item" : "New Activity"
        };
    },
    watch: {
        "form.item.addAsActivity"(value) {
            this.isAddAsActivity = value == 1;
        }
    },
    computed: {
        templateId() {
            return this.$store.state.settingsTemplate.details.id;
        },
        isItemPage() {
            return this.page === ITEM_PAGE;
        },
        isActivityPage() {
            return this.page === ACTIVITY_PAGE;
        },
        isItemPageSaveDisabled() {
            return this.saveState.item === false;
        },
        isActivityPageSaveDisabled() {
            return this.isAddAsActivity && this.saveState.activity === false;
        }
    },
    methods: {
        async open(isEdit, formData) {
            let form = {};
            this.isEdit = isEdit ? true : false;
            this.$refs.modalDialog.open();
            await this.$nextTick();

            if (this.isEdit && formData) {
                this.title = "Edit Item";
                this.$set(formData.item, "label", formData.item.name);
                this.$set(
                    formData.item,
                    "uom",
                    formData.item.measurement_unit.value
                );
                form = {
                    item: formData.item,
                    id: formData.id,
                    quantity: formData.quantity,
                    unitPrice: formData.unit_price.toFixed(2),
                    totalPrice: formData.total_price.toFixed(2),
                    printOnInvoice: formData.print_on_invoice,
                    isCustomPrice: formData.is_custom_price,
                    fees: _.map(formData.fees, fee => {
                        return {
                            id: fee.id,
                            name: fee.name,
                            encoded_id: fee.encoded_id,
                            price: fee.price
                        };
                    }),
                    feesTotal: formData.fees_total,
                    actions: [],
                    addAsActivity: "0"
                };
                // mergeData = _.merge(form, this.formData);
                this.form.item = form;
                this.$refs.itemPage.mergeData(form);
            }
        },
        reset() {
            this.isEdit = false;
            this.$refs.itemPage.reset();

            if (this.isActivityPage) {
                this.$refs.activityPage.reset();
            }

            this.form.item = {};
            this.form.activity = {};

            this.page = ITEM_PAGE;
        },
        close() {
            this.reset();
            this.$refs.modalDialog.close();
            this.$emit("close");
        },
        updateItemForm(data) {
            this.form.item = data;
            this.form.activity.quantity = data.quantity;
        },
        async save(isAddNew) {
            let isValid = false;

            if (this.isItemPage && !this.isAddAsActivity) {
                isValid = await this.$refs.itemPage.$validator.validateAll();
            } else if (this.isActivityPage && this.isAddAsActivity) {
                isValid = await this.$refs.itemPage.$validator.validateAll();
                isValid = await this.$refs.activityPage.$validator.validateAll();
            }

            if (!isValid) {
                return;
            }

            try {
                this.isSaving = true;

                if (this.isItemPage && !this.isAddAsActivity) {
                    await this.$refs.itemPage.save();
                } else if (this.isActivityPage && this.isAddAsActivity) {
                    await this.$refs.itemPage.save();
                    await this.$refs.activityPage.save();
                }

                this.$emit("onsuccess");

                if (isAddNew) {
                    this.reset();
                } else {
                    this.close();
                }
            } catch (error) {
                console.log(error);
                this._message("Error saving data", "danger");
            } finally {
                this.isSaving = false;
            }
        },

        back() {
            if (!this.isActivityPage) {
                return;
            }

            this.page = ITEM_PAGE;
        },

        async next() {
            if (!this.isAddAsActivity || !this.isItemPage) {
                return;
            }

            const isValid = await this.$refs.itemPage.$validator.validateAll();

            if (!isValid) {
                return;
            }

            this.page = ACTIVITY_PAGE;
        }
    }
};
</script>
